import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import moment from "moment";

const RunsheetList = () => {
  const defaultColumns: any = [
    {
      header: "Waybill",
      accessorKey: "tracking_number",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ? moment(getValue()).format('YY-MM-DD HH:mm:ss') : "N/A"}</p>
          </>
        )
      },
    },
    {
      header: "Vehicle",
      accessorKey: "vehicle.name",
      cell: NACell,
    },
    {
      header: "Driver",
      accessorKey: "driver.full_name",
      cell: NACell,
    },
    {
      header: "Total Items",
      accessorKey: "total_items",
      cell: NACell,
    },
    {
      header: "Destination",
      accessorKey: "destination_branch.name",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={`${APIS.MANIFEST}`}
      queryKey={"runsheet"}
      params={{
        type:"runsheet"
      }}
      columns={defaultColumns}
      addNewPagePath={"/create-runsheet"}
      tableName={"Runsheet"}
    />
  );
};

export default RunsheetList;
